import { useEffect, useState } from 'react';

const isBrowserEnvironment = (): boolean => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export function useMatchMedia(query: string): boolean {
    const [queryMatch, setQueryMatch] = useState(false);

    useEffect(() => {
        if (!isBrowserEnvironment()) {
            return;
        }

        const mediaQueryList = window.matchMedia(`(min-width: ${query})`);
        const handleChange = (event?: MediaQueryListEvent) => {
            setQueryMatch(event?.matches ?? mediaQueryList.matches);
        };

        handleChange();

        if (typeof mediaQueryList.addEventListener === 'function') {
            mediaQueryList.addEventListener('change', handleChange);
            return () => mediaQueryList.removeEventListener('change', handleChange);
        }

        mediaQueryList.addListener(handleChange);
        return () => mediaQueryList.removeListener(handleChange);
    }, [query]);

    return queryMatch;
}
